import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './ResultList.scss';

const ResultList = ({ posts, onSort }) => (
    <div className="SearchResultList">
        {posts.map((item, index) =>
            <ResultItem key={index} item={item} />
        )}
    </div>
);

class ResultItem extends PureComponent {
    state = {
        showDescription: false
    }

    stripHTML = (txt) => {
       let fixedTxt = txt.replace( /(<([^>]+)>)/ig, '');
       return fixedTxt.replace('&hellip;', '...');
    }

    render(){
        const { item } = this.props;

        return [
            <a
                className="SearchResultList__Row"
                key={`${item.Class}`}
                href={item.url}
            >
                <div className="SearchResultList__Content">
                    <div className="SearchResultList__Label">{item.category}</div>
                    <div className="SearchResultList__Title">{item.title}</div>

                    <p className="SearchResultList__Text">{this.stripHTML(item.excerpt)}</p>

                    { item.subtype.includes('product') &&
                        <p className="SearchResultList__Link">Till produkten</p>
                    }

                </div>

                { item.featured_image_src &&
                    <img className="SearchResultList__Image" src={item.featured_image_src} alt="" />
                }
            </a>
        ]
    }
}

ResultList.propTypes = {
    posts: PropTypes.array.isRequired,
};

ResultList.defaultProps = {
    posts: []
};

export default ResultList;
